module.exports = __webpack_public_path__ + "static/media/gameWin.d89d1a34.mp3";